import React, { createContext } from "react";
import { contextAsyncFunctionInit, contextFunctionInit } from "sprint-common-web";

import { NoteItem } from "../../../../common/components/notes/hooks/state/NoteItem";
import { FileRecordStatus } from "../../../../common/types/FileRecordStatus";
import { FileRecordStatusDetails } from "../../common/types/FileRecordStatusDetails";
import { getDefaultFileRecordListingConfig, FileRecordListingConfig } from "../config/FileRecordListingConfig";
import { FileRecordListingFilters } from "../hooks/useFileRecordListingFilters";
import { FileRecordListingItem } from "../types/FileRecordListingItem";

interface IFileRecordListingContext {
    notes?: Record<string, NoteItem[]>;
    items: FileRecordListingItem[];
    selectedItems: FileRecordListingItem[];
    totalItems: number;
    areNotesLoading: boolean;
    areFileRecordsLoading: boolean;
    listingConfig: FileRecordListingConfig;
    setSelectedItems(selectedItems: FileRecordListingItem[]): void;
    reloadData: (filters: FileRecordListingFilters) => Promise<void>;
    rejectFileRecord(fileRecordId: string): void;
    addFileRecordItems(item: FileRecordListingItem[]): void;
    removeFileRecord(itemId: string): void;
    approveNotifications(fileRecordId: string): void;
    updateFileRecordStatus(
        fileRecordId: string,
        status: FileRecordStatus,
        statusDetails?: FileRecordStatusDetails
    ): void;
    saveListingConfig(cfg: FileRecordListingConfig): void;
}

export const FileRecordListingContext = createContext<IFileRecordListingContext>({
    notes: undefined,
    items: [],
    selectedItems: [],
    totalItems: 0,
    areNotesLoading: true,
    areFileRecordsLoading: true,
    listingConfig: getDefaultFileRecordListingConfig(),
    updateFileRecordStatus: contextFunctionInit,
    setSelectedItems: contextAsyncFunctionInit,
    reloadData: contextAsyncFunctionInit,
    addFileRecordItems: contextFunctionInit,
    rejectFileRecord: contextFunctionInit,
    removeFileRecord: contextFunctionInit,
    approveNotifications: contextFunctionInit,
    saveListingConfig: contextFunctionInit
});
